import { render, staticRenderFns } from "./navComp.vue?vue&type=template&id=215af105&scoped=true&"
import script from "./navComp.vue?vue&type=script&lang=js&"
export * from "./navComp.vue?vue&type=script&lang=js&"
import style0 from "./navComp.vue?vue&type=style&index=0&id=215af105&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215af105",
  null
  
)

export default component.exports